<script setup lang="ts">
import CommonInput from "~/components/Common/Inputs/CommonInput.vue";
import Editor from "~/components/Common/Rich-text-editor/Editor.vue";
import { useLearningPathValidation } from "~/composables/learning-path/useLearningPathValidation";
import { useLearningPathStore } from "~/store/learning-path/learning-path.store";

const { form } = storeToRefs(useLearningPathStore());
const { validateStepGeneral } = useLearningPathValidation();
const $e = validateStepGeneral();
</script>

<template>
  <div class="flex flex-col gap-4 px-2">
    <h3 class="heading_3_demi text-primary-color">Informations générales</h3>
    <div class="flex flex-col px-4 gap-2">
      <div class="flex flex-col gap-2">
        <span class="body_regular text-secondary-color">Nom*</span>
        <CommonInput
          v-model="form.general.name"
          :error="!!$e.$errors.find((err: any) => err.$property === 'name')"
          placeholder="Nom du parcours"
          style="text-align: left"
        />
        <span
          v-if="!!$e.$errors.find((err: any) => err.$property === 'name')"
          class="text-primary-red-color body_regular"
          >Ce champ est obligatoire</span
        >
      </div>
      <div class="flex flex-col">
        <span class="body_regular text-secondary-color">Description</span>
        <Editor
          v-model="form.general.description"
          :actions-list="['default', 'list', 'blockquote', 'separator', 'justify', 'text-style', 'color-text', 'link']"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
